<div class="header-toolbar">
  <div class="toolbar" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
    <div class="clickable" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" [routerLink]="'/'">
      <img height="55" width="auto" src="assets/images/rs_logo_blue_white_inline_transparent_cropped.png" alt="RetailStat Grocery Insights Logo"/>
    </div>
    <div fxFlex></div>
    <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px" *ngIf="isAuthenticated; else notAuthenticated">
      <mtn-simple-alert *ngIf="!license?.suspendedDate && license?.isExpired()"
                        title="{{ 'LICENSE_EXPIRED_TITLE' | translate }}"
                        text="{{ 'LICENSE_EXPIRED_TEXT' | translate }}"
                        icon="exclamation-circle"
                        (alertClick)="openLicenseExpiredWizard()"></mtn-simple-alert>
      <mtn-simple-alert *ngIf="license?.suspendedDate"
                        title="{{ 'LICENSE_SUSPENDED_TITLE' | translate }}"
                        text="{{ 'LICENSE_SUSPENDED_TEXT' | translate }}"
                        icon="exclamation-circle" color="red"
                        (alertClick)="openLicenseSuspendedWizard()"></mtn-simple-alert>
      <mtn-current-user-chip-and-menu></mtn-current-user-chip-and-menu>
    </div>
    <ng-template #notAuthenticated>
      <button mat-raised-button color="primary" *ngIf="!isAuthenticated" (click)="openAuth0SignInDialog()"
              mtnAnalyticsEventTrigger [analyticsEventName]="AnalyticsEventType.LOG_IN" fxHide.gt-sm>
        {{ 'SIGN_IN' | translate }}
      </button>
    </ng-template>
  </div>
  <div class="header-fader"></div>
</div>
